import { render, staticRenderFns } from "./frUserProtocol.vue?vue&type=template&id=f729e9e6&scoped=true&"
import script from "./frUserProtocol.vue?vue&type=script&lang=js&"
export * from "./frUserProtocol.vue?vue&type=script&lang=js&"
import style0 from "./frUserProtocol.vue?vue&type=style&index=0&id=f729e9e6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f729e9e6",
  null
  
)

export default component.exports